import { createSearchParams, } from "react-router-dom";
import { LoginSource } from "@domains/utils/emtReportCallback";
import config from "@frameworks/web/config/domain";
import { scroller } from "react-scroll";
export const navigateRoute = (location, navigate, destination, paramName) => {
    const searchParams = new URLSearchParams(location.search);
    if (location.pathname) {
        let options = {
            pathname: location.pathname,
            search: `${!!location.search ? location.search + "&" : "?"}${createSearchParams({
                [paramName ? paramName : "sectionName"]: destination,
            })}`,
        };
        if (searchParams.get(paramName) || searchParams.get("sectionName")) {
            searchParams.set(paramName || "sectionName", destination);
            options.search = searchParams.toString();
        }
        navigate(options, { replace: true });
    }
    scrollToSection(destination);
};
export const scrollToSection = (scrollSectionName) => {
    setTimeout(() => {
        scroller.scrollTo(scrollSectionName, {
            behaviour: "smooth",
            offset: -280,
        });
    }, 10);
};
export const getFinalShareUrl = (sectionName, id, tabName) => {
    const url = new URL(window.location.href.split("?").length > 1
        ? window.location.href.split("?")[0]
        : window.location.href.split("#").length > 1
            ? window.location.href.split("#")[0]
            : window.location.href);
    if (sectionName || id) {
        url.searchParams.append("sectionName", sectionName || id);
    }
    if (tabName && !url.searchParams.has("tabName")) {
        url.searchParams.append("tabName", tabName);
    }
    return url.toString();
};
export const getLoginSourceURL = (loginSource) => {
    if (loginSource == LoginSource.SALES)
        return config.feReportBase + "/" + LoginSource.SALES;
    return config.feReportBase;
};
